export default "__VITE_ASSET__CXDh59l0__"